export const createHeaders = () => {
  const authUser = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    // webVersion: environment.versions.app,
  };
  if (authUser) {
    const a_token = JSON.parse(authUser);
    return {
      ...headers,
      Authorization: 'Bearer ' + a_token,
      authServiceValidated: 'true',
    };
  } else {
    return headers;
  }
};

export const createTokenHeader = () => {
  const authUser = localStorage.getItem('authToken');
  const headers = {
    'content-type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    // webVersion: environment.versions.app,
  };
  if (authUser) {
    const a_token = JSON.parse(authUser);
    return {
      ...headers,
      Authorization: 'Bearer ' + a_token,
      authServiceValidated: 'true',
    };
  } else {
    return headers;
  }
};
export const createGraphqlHeader = () => {
  const authUser = localStorage?.getItem(
    'authToken'
  ) as string;

  const headers = {
    'Content-Type': 'application/json',
  };

  const a_token = JSON?.parse(authUser);
  return {
    ...headers,
    Authorization: 'Bearer ' + a_token,
  };
};
